import React, { Component } from 'react';
import IntlMessages from 'util/IntlMessages';
import Maps from 'containers/Maps';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';
import Lightbox from 'react-images';
import Duplicates from './Duplicates';
import SVGInline from 'react-svg-inline';
import { injectIntl, intlShape } from 'react-intl';

class Summary extends Component {
	constructor(props) {
		super(props);
		this.state = { currentImage: 0, lightboxIsOpen: false, termsOfUseAccepted: false, dataProtection: false };
	}

	_lightboxOnPrevious = () => {
		const nextImage = this.state.currentImage - 1;
		this.setState({ currentImage: nextImage });
		this._imageGallery.slideToIndex(nextImage);
	};

	_lightboxOnNext = () => {
		const nextImage = this.state.currentImage + 1;
		this.setState({ currentImage: nextImage });
		this._imageGallery.slideToIndex(nextImage);
	};

	render() {
		const { colors, requirements, modules } = this.props.settings;
		const { selectedPosition, images, firstName, lastName, email, phone, description, selectedType, sendButtonDisabled } = this.props.data;
		const type = _.find(this.props.settings.types, { id: selectedType });

		// console.log('sendButtonDisabled: ', sendButtonDisabled);

		// console.log('images:', images);

		return (
			<div className="row">
				<div className={modules.reportDuplicates ? 'col-lg-8 col-md-12' : 'col-lg-12 col-md-12'}>
					<Card>
						<CardHeader className="custom-main">
							<IntlMessages id="meldooWeb.newReport.summary.title" />
						</CardHeader>
						<CardBody>
							<div className="row">
								<div className="col-lg-6 col-sm-6 col-12">
									<Card>
										<CardBody className="p-0">
											<Maps
												center={selectedPosition}
												data={[
													{
														reportId: 1,
														latlng: selectedPosition,
														status: 1,
														type: { id: selectedType }
													}
												]}
												types={this.props.settings.types}
												dimensions="4by3"
											/>
										</CardBody>
									</Card>
								</div>
								<div className="col-lg-6 col-sm-6 col-12">
									<Card className="jr-card-full-height p-0 border-0">
										<CardBody className="p-0">
											<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
												<div>
													<strong>
														<IntlMessages id="meldooWeb.reportDetails.props.type" />:
													</strong>
												</div>
												<div>{type ? type.name : <IntlMessages id="common.undefined" />}</div>
											</div>
											{requirements.description.show && (
												<div className="border-bottom pb-2 mb-2">
													<div className="mb-2">
														<strong>
															<IntlMessages id="meldooWeb.reportDetails.props.description" />:
														</strong>
													</div>
													<div>{description}</div>
												</div>
											)}
											<div className="border-bottom mb-2">
												<div className="mb-2">
													<strong>
														<IntlMessages id="meldooWeb.reportDetails.props.images" />:
													</strong>
												</div>
												<div className="gl-single-line justify-content-start">
													<div className="slg row g-ul m-0">
														{images.map((image, index) => (
															<div
																key={index}
																className="grid pointer"
																style={{ height: 100, width: 100, marginRight: 10 }}
																onClick={() =>
																	this.setState({
																		currentImage: index,
																		lightboxIsOpen: true
																	})
																}
															>
																<img src={image.preview} alt={image.title} style={{ width: '150%' }} />
															</div>
														))}
													</div>
													<Lightbox
														images={images.map(value => {
															return {
																src: value.preview,
																srcSet: [`${value.preview} 1024w`]
															};
														})}
														currentImage={this.state.currentImage}
														isOpen={this.state.lightboxIsOpen}
														onClickPrev={this._lightboxOnPrevious}
														onClickNext={this._lightboxOnNext}
														onClose={() =>
															this.setState({
																lightboxIsOpen: false,
																lightboxImageZoom: false
															})
														}
														showImageCount={false}
														onClickImage={() => console.log('click')}
														backdropClosesModal
														width={2048}
													/>
												</div>
											</div>
											{requirements.name.show && (
												<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
													<div className="mb-2">
														<strong>
															<IntlMessages id="common.firstName" />:
														</strong>
													</div>
													<div>{firstName}</div>
												</div>
											)}
											{requirements.name.show && (
												<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
													<div className="mb-2">
														<strong>
															<IntlMessages id="common.lastName" />:
														</strong>
													</div>
													<div>{lastName}</div>
												</div>
											)}
											{requirements.email.show && (
												<div className="d-flex justify-content-between border-bottom pb-2 mb-2">
													<div className="mb-2">
														<strong>
															<IntlMessages id="common.email" />:
														</strong>
													</div>
													<div>{email}</div>
												</div>
											)}
											{requirements.phone.show && (
												<div className="d-flex justify-content-between mb-2">
													<div className="mb-2">
														<strong>
															<IntlMessages id="common.phone" />:
														</strong>
													</div>
													<div>{phone}</div>
												</div>
											)}
										</CardBody>
									</Card>
								</div>
								<div className="col-12">
									<div className="custom-control custom-checkbox my-1 mr-sm-2 ml-3">
										<input
											type="checkbox"
											className="custom-control-input"
											id="termsOfUseAccepted"
											checked={this.state.termsOfUseAccepted}
											onChange={() =>
												this.setState({
													termsOfUseAccepted: !this.state.termsOfUseAccepted
												})
											}
											disabled={this.props.loading.sendingReport}
										/>
										<label className="custom-control-label mt-1" htmlFor="termsOfUseAccepted">
											<strong>
												Ich habe die{' '}
												<a target="_blank" href="https://www.leanact.de/agb-und-datenschutz/">
													Nutzungsbedingungen
												</a>{' '}
												gelesen und akzeptiere diese. Diese können Sie{' '}
												<a target="_blank" href="https://www.leanact.de/agb-und-datenschutz/">
													hier
												</a>{' '}
												einsehen.
											</strong>
										</label>
									</div>
								</div>
								<div className="col-12 mb-3">
									<div className="custom-control custom-checkbox my-1 mr-sm-2 ml-3">
										<input
											type="checkbox"
											className="custom-control-input"
											id="dataProtection"
											checked={this.state.dataProtection}
											onChange={() =>
												this.setState({
													dataProtection: !this.state.dataProtection
												})
											}
											disabled={this.props.loading.dataProtection}
										/>
										<label className="custom-control-label mt-1" htmlFor="dataProtection">
											<strong>
												Ich habe die{' '}
												<a target="_blank" href="https://www.leanact.de/agb-und-datenschutz/">
													Datenschutzbestimmung
												</a>{' '}
												gelesen und akzeptiere diese. Diese können Sie{' '}
												<a target="_blank" href="https://www.leanact.de/agb-und-datenschutz/">
													hier
												</a>{' '}
												einsehen.
											</strong>
										</label>
									</div>
								</div>
								<div className="col-12">
									<div className="d-flex flex-wrap align-items-center">
										{this.props.loading.captcha || !this.props.captcha ? (
											<div
												style={{ width: 152, height: 58 }}
												className="mr-3 mb-3 border d-flex justify-content-center align-items-center"
											>
												<i className="zmdi zmdi-spinner zmdi-hc-spin" />
											</div>
										) : (
											<SVGInline svg={this.props.captcha} className="mr-3 mb-3 border" />
										)}

										<div className="mb-3">
											<Button
												color="default"
												className="jr-btn jr-btn-default jr-btn-sm"
												onClick={this.props.newCatpcha}
												style={{ backgroundColor: colors.main.bg, color: colors.main.font }}
												disabled={this.props.loading.captcha}
											>
												{this.props.loading.captcha ? (
													<i className="zmdi zmdi-spinner zmdi-hc-spin" />
												) : (
													<i className="zmdi zmdi-replay zmdi-hc-lg" />
												)}

												<IntlMessages id="meldooWeb.newReport.captcha.newCaptcha" />
											</Button>
										</div>
									</div>
									<div className="form-group">
										<input
											className={`form-control form-control-lg ${this.props.errorMessages.captcha && 'is-invalid'}`}
											value={this.props.captchaInputValue}
											onChange={m => this.props.onCaptchaInputUpdate(m.target.value)}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'meldooWeb.newReport.captcha.input.placeholder'
											})}
										/>
										<div className="invalid-feedback">
											<IntlMessages id="meldooWeb.newReport.errors.captcha" />
										</div>
									</div>
								</div>
							</div>
						</CardBody>
					</Card>
					<div className="d-flex w-100 justify-content-between">
						<Button color="default" className="jr-btn jr-btn-default custom-previous" onClick={this.props.onPreviousStep}>
							<i className="zmdi zmdi-chevron-left zmdi-hc-lg" />
							<IntlMessages id="meldooWeb.newReport.previousStep" />
						</Button>
						<Button
							color="default"
							className="jr-btn jr-btn-default custom-next"
							onClick={this.props.onNextStep}
							disabled={!this.state.termsOfUseAccepted || !this.state.dataProtection || sendButtonDisabled}
						>
							<i className="zmdi zmdi-mail-send zmdi-hc-lg" />
							{sendButtonDisabled ? <IntlMessages id="common.sendDataPleaseWait" /> : <IntlMessages id="common.send" />}
						</Button>
					</div>
				</div>
				{modules.reportDuplicates && (
					<div className="col-lg-4 col-md-12">
						<Duplicates duplicates={this.props.duplicates} colors={colors} toReport={this.props.toReport} />
					</div>
				)}
			</div>
		);
	}
}

Summary.propTypes = {
	intl: intlShape.isRequired
};

export default injectIntl(Summary);



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/NewReport/Component/Summary.js